import { aspenApi as api, getFundDetail } from "@aspen/services";
import { generateDataCacheKey, loadData } from "@aspen/libs";
import { useQuery } from "@tanstack/react-query";
import type { IReqFundDetail, IRes } from "@aspen/model";
import { useUpdateQueryCache } from "./useUpdateQueryCache";

/**
 * 获取Fund产品详情。
 * @param {IReqFundDetail} params - 获取Fund产品详情所需的参数。
 */
export const useFetchFundDetail = (params: IReqFundDetail) => {
  const apiPath = api.fund.fundDetail;
  const queryKey = generateDataCacheKey({ api: apiPath, params: JSON.stringify(params) });
  const cacheData = loadData<IRes>(queryKey);

  const { error, data, isLoading, refetch, isFetching, isPlaceholderData } = useQuery({
    queryKey: [queryKey, Object.values(params)],
    queryFn: () => {
      return getFundDetail(params).then(res => {
        return res;
      });
    },
    placeholderData: cacheData,
    refetchOnMount: true, // 覆盖全局配置，确保每次进入页面时都重新请求
  });
  useUpdateQueryCache(queryKey, data, cacheData, isPlaceholderData);
  return { error, data, refetch, queryKey, isLoading, isFetching, isPlaceholderData };
};
